import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
import { OrderBasisFactory } from '@/coreDomainsModule/factories/OrderBasisFactory';
import { OrderBasis, OrderBasisCustomerAnnounceDaily } from '@/coreInfrastructureModule/axios/generated/orderBasisManage';

/**
 * OrderBasisのAdapter
 */
export class OrderBasisAdapter {
  /**
   * 発注根拠の日別内示をIAnnounceDailyに変換する
   * @param response - APIの日別内示情報
   * @returns - IAnnounceDaily配列
   */
  private static adaptCustomerAnnounceDaily = (response?: OrderBasisCustomerAnnounceDaily[]) => {
    if (!response) return [];
    return response.map((announce) => ({
      year: announce.customerForecastTargetYear,
      month: announce.customerForecastTargetMonth,
      day: announce.customerForecastTargetDay,
      amount: announce.customerForecastAmount,
      manageInitiatedYearMonth: {
        year: announce.customerForecastReceivedYear,
        month: announce.customerForecastReceivedMonth,
      },
      createAt: undefined,
      updateAt: undefined,
    }));
  };
  /**
   * 取得した発注根拠からIOrderBasisを生成する
   * @param result - 取得した情報
   * @returns - IOrderBasis型の発注根拠情報
   */
  public static adapt = (result: OrderBasis): IOrderBasis => {
    return OrderBasisFactory.create({
      orderBasisId: result.orderBasisId,
      snapshotExecutionDate: result.snapshotExecutionDate,
      snapshotLatestInventoryAmount: result.snapshotLatestInventoryAmount,
      snapshotMoq: result.snapshotMoq,
      snapshotPackage: result.snapshotPackage,
      userAdjustedLeadTime: {
        value: result.userAdjustedLeadTime,
        unit: result.userAdjustedLeadTimeUnit,
      },
      userAdjustedStdInventoryIndex: {
        min: result.userAdjustedStdInventoryIndexMin,
        max: result.userAdjustedStdInventoryIndexMax,
        option: {
          unit: result.userAdjustedStdInventoryIndexUnit,
        },
      },
      nextMonthlyInfos: result.nextMonthlyInfos.map((nextMonthlyInfo) => ({
        orderBasisTargetYearMonth: { year: nextMonthlyInfo.orderBasisTargetYear, month: nextMonthlyInfo.orderBasisTargetMonth },
        userAdjustedCustomerForecastAmount: nextMonthlyInfo.userAdjustedCustomerForecastAmount,
        snapshotCustomerForecastAmount: nextMonthlyInfo.snapshotCustomerForecastAmount,
        snapshotPreInventoryAmount: nextMonthlyInfo.snapshotPreInventoryAmount,
        dailyInfos:
          nextMonthlyInfo.dailyInfos?.map((nextDailyInfo) => ({
            orderBasisTargetDay: nextDailyInfo.orderBasisTargetDay,
            snapshotArrivalAmount: nextDailyInfo.snapshotArrivalAmount,
          })) ?? [],
      })),
      pastMonthlyInfos: result.pastMonthlyInfos.map((pastMonthlyInfo) => ({
        orderBasisTargetYearMonth: { year: pastMonthlyInfo.orderBasisTargetYear, month: pastMonthlyInfo.orderBasisTargetMonth },
        snapshotCustomerForecastAmount: pastMonthlyInfo.snapshotCustomerForecastAmount,
        snapshotSalesResultAmount: pastMonthlyInfo.snapshotSalesResultAmount,
      })),
      customerAnnounceDaily: OrderBasisAdapter.adaptCustomerAnnounceDaily(result.customerAnnounceDaily),
    });
  };
}
